<!-- // 景观项目 -->
<template>
  <el-card>
    <el-form inline ref="searchInfo" :model="info" class="global-form1">
      <el-form-item prop="itemName">
        <el-input v-model="info.itemName" placeholder="请输入预约项目名称" clearable></el-input>
      </el-form-item>
      <el-form-item prop="projectId">
        <el-select v-model="info.projectId" placeholder="请选择公园名称" clearable filterable>
          <el-option v-for="(item, index) in this.parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="itemStatus">
        <el-select v-model="info.itemStatus" placeholder="请选择开启状态" clearable>
          <el-option label="已开启" value="1"></el-option>
          <el-option label="已关闭" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <!-- v-visible="'add'" -->
    <el-button class="mb20" @click='onAdd' type="primary" icon='el-icon-plus' v-if="$ButtonShow('AIN_ADD_01')">添加项目</el-button>
    <!-- <el-button class="mb20" @click='onType' type="primary" v-visible="'type'">防疫设置</el-button> -->
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="预约项目名称" show-overflow-tooltip prop="itemName"></el-table-column>
      <el-table-column label="所属公园" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="预约入园时间段" show-overflow-tooltip prop="appointItemTimeList">
        <template v-slot="{ row }">
          {{ row.appointItemTimeList | filterTimeList }}
        </template>
      </el-table-column>
      <el-table-column label="开启状态" show-overflow-tooltip prop="itemStatus">
        <template v-slot="{ row }">
          <el-switch v-model="row.itemStatus" active-color="#13ce66" inactive-color="#bbbbbb" active-value="1"
            inactive-value="0" :disabled="!$ButtonShow('AIN_EDT_01')" @change="changeStatus(row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="110px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.itemId)">查看</el-button>
          <el-button type="text" @click="onDelete(row.itemId)" v-if="$ButtonShow('AIN_DEL_01')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
  </el-card>

</template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Project',
  mixins: [keepAlive],
  components: {
  },
  filters: {
    filterTimeList: function (value) {
      return value.map((item) => {
        return item.startTime + '-' + item.endTime
      }).join(',')
    }
  },
  data() {
    return {
      info: {
        projectName: '',
        projectId: '',
        itemStatus: ''
      },
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      parkList: []
    }
  },
  created() {
    this.getPark()
    this.loadData()
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    changeStatus(row) {
      console.log(row, 'row');
      this.$axios.post(this.$apis.tourist.updateAppointItemStatus, {
        itemId: row.itemId,
        itemStatus: row.itemStatus
      }).then(() => {
        this.$message.success('状态设置成功')
        this.loadData()
      }).catch(() => {
        this.loadData()
      })
    },
    onType() {
      this.isShowType = true
    },
    loadData() {
      this.loading = true
      const params = {
        ...this.info,
        page: this.page,
        size: this.size,
        isCad: 0
      }
      this.$axios.get(this.$apis.tourist.selectAppointItemByPage, {
        ...params
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onAdd() {
      this.$router.push('/appointproject/add')
    },
    onDetail(id) {
      console.log(id, 'id')
      this.$router.push({
        name: 'AppointprojectDetail',
        params: { id }
      })
    },
    onDelete(id) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.tourist.deleteAppointItem, {
          itemId: id
        }).then(() => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
